import { getUsers, getUserAllSubscriptions, deleteUser, createUserSubscription } from "../../services/user.services";
import { getAllSubscriptionsType } from "../../services/subscriptions.services";


const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

const FETCH_USER_SUBSCRIPTIONS_REQUEST = "FETCH_USER_SUBSCRIPTIONS_REQUEST";
const FETCH_USER_SUBSCRIPTIONS_SUCCESS = "FETCH_USER_SUBSCRIPTIONS_SUCCESS";
const FETCH_USER_SUBSCRIPTIONS_FAILURE = "FETCH_USER_SUBSCRIPTIONS_FAILURE";

const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

const CREATE_USER_SUBSCRIPTION_REQUEST = "CREATE_USER_SUBSCRIPTION_REQUEST";
const CREATE_USER_SUBSCRIPTION_SUCCESS = "CREATE_USER_SUBSCRIPTION_SUCCESS";
const CREATE_USER_SUBSCRIPTION_FAILURE = "CREATE_USER_SUBSCRIPTION_FAILURE";

const FETCH_SUBSCRIPTIONS_TYPE_REQUEST = "FETCH_SUBSCRIPTIONS_TYPE_REQUEST";
const FETCH_SUBSCRIPTIONS_TYPE_SUCCESS = "FETCH_SUBSCRIPTIONS_TYPE_SUCCESS";
const FETCH_SUBSCRIPTIONS_TYPE_FAILURE = "FETCH_SUBSCRIPTIONS_TYPE_FAILURE";


export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: FETCH_USERS_REQUEST });
  try {
    const response = await getUsers(JSON.parse(sessionStorage.getItem("myData")));
    dispatch({ type: FETCH_USERS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_USERS_FAILURE, payload: error });
  }
};

export const fetchUserSubscriptions = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_USER_SUBSCRIPTIONS_REQUEST });
  try {
    const response = await getUserAllSubscriptions({ userId }, JSON.parse(sessionStorage.getItem("myData")));
    dispatch({ type: FETCH_USER_SUBSCRIPTIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_USER_SUBSCRIPTIONS_FAILURE, payload: error });
  }
};

export const deleteUserAction = (userId) => async (dispatch) => {
  dispatch({ type: DELETE_USER_REQUEST });
  try {
    const response = await deleteUser(userId, JSON.parse(sessionStorage.getItem("myData")));
    dispatch({ type: DELETE_USER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: DELETE_USER_FAILURE, payload: error });
  }
};

export const createUserSubscriptionAction = (subscriptionData) => async (dispatch) => {
  dispatch({ type: CREATE_USER_SUBSCRIPTION_REQUEST });
  try {
    const response = await createUserSubscription(subscriptionData, JSON.parse(sessionStorage.getItem("myData")));
    dispatch({ type: CREATE_USER_SUBSCRIPTION_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: CREATE_USER_SUBSCRIPTION_FAILURE, payload: error });
  }
};

export const fetchSubscriptionsType = () => async (dispatch) => {
  dispatch({ type: FETCH_SUBSCRIPTIONS_TYPE_REQUEST });
  try {
    const response = await getAllSubscriptionsType(JSON.parse(sessionStorage.getItem("myData")));
    dispatch({ type: FETCH_SUBSCRIPTIONS_TYPE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_SUBSCRIPTIONS_TYPE_FAILURE, payload: error });
  }
};